// Redux Action Types
import { SET_MEASURES } from '../actions/types';
// Initial State
const initialState = [];

export default function (state = initialState, action) {
  if (action.type === SET_MEASURES) return action.payload;
  return state;
}
